// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电力系统分析",
      "tec": "张晓慧卢颖",
      "week": "1-15周",
      "add": "教学楼A座116电力"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "徐凤莉",
        "week": "1-8周",
        "add": "教学楼C座114教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "徐凤莉",
        "week": "9-12周",
        "add": "教学楼C座114教务"
      }
    ],
    {
      "sub": "自动控制原理",
      "tec": "王伟平",
      "week": "1,3,5,7,9,11,13-15周",
      "add": "教学楼C座214教务"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "电力电子技术",
      "tec": "李鑫",
      "week": "1-15周",
      "add": "教学楼C座214教务"
    },
    {
      "sub": "电力系统分析",
      "tec": "张晓慧卢颖",
      "week": "1,3,5周",
      "add": "教学楼A座116电力"
    },
    0,
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "9-12周",
      "add": "大活礼堂"
    }
  ],
  "3": [
    {
      "sub": "自动控制原理",
      "tec": "王伟平",
      "week": "1-15周",
      "add": "教学楼A座225电力"
    },
    {
      "sub": "电力系统分析",
      "tec": "张晓慧卢颖",
      "week": "1-15周",
      "add": "教学楼A座116电力"
    },
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "工程伦理",
      "tec": "艾静超",
      "week": "1-8周",
      "add": "教学楼A座116电力"
    },
    {
      "sub": "电力电子技术",
      "tec": "李鑫",
      "week": "7-15周",
      "add": "教学楼A座221电力"
    },
    0,
    0,
    0
  ],
  "5": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "徐凤莉",
        "week": "1-8周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "徐凤莉",
        "week": "9-12周",
        "add": "教学楼A座118电力"
      }
    ],
    {
      "sub": "电力系统分析",
      "tec": "张晓慧卢颖",
      "week": "1-15周",
      "add": "教学楼A座116电力"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
